import AvatarShimmer from "@gx/dls/avatar/AvatarShimmer";
import FlexWrapper, {
  AlignItems,
  FlexDirection,
  JustifyContent,
} from "@gx/dls/containers/FlexWrapper";
import HorizontalDivider from "@gx/dls/dividers/HorizontalDivider";
import TextShimmer from "@gx/dls/text/TextShimmer";
import Widget from "@gx/dls/widget/Widget";

import { SourceCardProps } from "@/pages/sources/components/card/SourceCard";

export const SourceCardLoadingStatus = () => {
  return (
    <FlexWrapper gap={6} alignItems={AlignItems.CENTER}>
      <TextShimmer height={8} width={8} />
      <TextShimmer height={16} width={72} />
    </FlexWrapper>
  );
};

export const SourceCardHeaderLoading = () => {
  return (
    <FlexWrapper
      justifyContent={JustifyContent.SPACE_BETWEEN}
      alignItems={AlignItems.CENTER}
      fillWidth
    >
      <FlexWrapper gap={8} alignItems={AlignItems.CENTER}>
        <AvatarShimmer size={28} />
        <TextShimmer height={20} width={128} />
      </FlexWrapper>
      <SourceCardLoadingStatus />
    </FlexWrapper>
  );
};

export const SourceCardBodyLoading = () => {
  return (
    <FlexWrapper gap={4} alignItems={AlignItems.CENTER}>
      <TextShimmer height={16} width={180} />
    </FlexWrapper>
  );
};

export const SourceCardMetricsLoading = () => {
  return (
    <FlexWrapper gap={8} alignItems={AlignItems.CENTER}>
      <TextShimmer height={18} width={36} />
      <TextShimmer height={18} width={36} />
    </FlexWrapper>
  );
};

export const SourceCardFooterLoading = () => {
  return (
    <FlexWrapper gap={4} alignItems={AlignItems.CENTER}>
      <TextShimmer height={16} width={240} />
    </FlexWrapper>
  );
};

const SourceCardLoading = ({
  noBody = false,
  noMetrics = false,
  noFooter = false,
}: Omit<SourceCardProps, "source">) => {
  return (
    <Widget fillWidth>
      <FlexWrapper gap={12} direction={FlexDirection.COLUMN}>
        <SourceCardHeaderLoading />
        {!noBody && <SourceCardBodyLoading />}
        {!noMetrics && <SourceCardMetricsLoading />}
        {!noFooter && (
          <>
            <HorizontalDivider />
            <SourceCardFooterLoading />
          </>
        )}
      </FlexWrapper>
    </Widget>
  );
};

export default SourceCardLoading;
